import React, { useState } from "react";
import API from "../../../services/api";

import "./OnlineToggle.css";

function OnlineToggle({

    online,

    refresh

}) {

    const [loading, setLoading] = useState(false);

    const handleToggle = async () => {

        try {

            setLoading(true);

            await API.patch(

                "/delivery/online",

                {

                    online: !online

                }

            );

            refresh();

        }

        catch (error) {

            console.log(error);

            alert(

                error.response?.data?.message ||

                "Unable to change status."

            );

        }

        finally {

            setLoading(false);

        }

    };

    return (

        <div className="online-card">

            <div className="online-top">

                <div
                    className={
                        online
                            ? "status online"
                            : "status offline"
                    }
                >

                    <span className="status-dot"></span>

                    {

                        online

                            ? "YOU ARE ONLINE"

                            : "YOU ARE OFFLINE"

                    }

                </div>

            </div>

            <button

                className={
                    online
                        ? "toggle-btn online-btn"
                        : "toggle-btn offline-btn"
                }

                onClick={handleToggle}

                disabled={loading}

            >

                {

                    loading

                        ? "Updating..."

                        : online

                            ? "Go Offline"

                            : "Go Online"

                }

            </button>

        </div>

    );

}

export default OnlineToggle;